import { Browser } from '@capacitor/browser';
import { registerPlugin } from '@capacitor/core';

import { IS_NATIVE } from '../../common/constants';

const TERMS_OF_USE_PDF_URL_BY_LANGUAGE: Record<string, string> = {
  'en-US': 'https://d3idm181rlx443.cloudfront.net/se_monitor_tou_en-US.pdf',
  'es-US': 'https://d3idm181rlx443.cloudfront.net/se_monitor_tou_es-US.pdf',
  'fr-CA': 'https://d3idm181rlx443.cloudfront.net/se_monitor_tou_fr-CA.pdf',
};

const DEFAULT_TERMS_OF_USE_PDF_URL = TERMS_OF_USE_PDF_URL_BY_LANGUAGE['en-US'];

interface NativePdfViewerPlugin {
  open(params: { url: string; title?: string }): Promise<void>;
}

const NativePdfViewer = registerPlugin<NativePdfViewerPlugin>('NativePdfViewer');

function getTermsOfUsePdfUrl(language: string): string {
  return TERMS_OF_USE_PDF_URL_BY_LANGUAGE[language] ?? DEFAULT_TERMS_OF_USE_PDF_URL;
}

/**
 * Opens Terms of Use PDF in native viewer (iOS/Android) or web browser.
 * Supports language-specific PDFs (en-US, es-US, fr-CA).
 *
 * @param language - Language code (e.g., 'en-US', 'es-US', 'fr-CA')
 */
export async function openTermsOfUsePdfInWebView(language: string): Promise<void> {
  const pdfUrl = getTermsOfUsePdfUrl(language);

  if (IS_NATIVE) {
    try {
      await NativePdfViewer.open({ url: pdfUrl, title: 'Terms of Use' });
      return;
    } catch (error) {
      const code =
        typeof error === 'object' && error !== null && 'code' in error
          ? String((error as { code?: unknown }).code)
          : '';
      if (code !== 'UNIMPLEMENTED') {
        throw error;
      }
    }
  }

  await Browser.open({ url: pdfUrl });
}
